import React from 'react'
import PropTypes from 'prop-types'

import Button from '../Button'
import { Download } from '../../icons'

const DownloadButton = ({ children, isProminent, ...otherProps }) => {
  return (
    <Button
      colorVariant='brand'
      fill={isProminent ? 'full' : 'outline'}
      size={isProminent ? 'regular' : 'small'}
      icon={<Download />}
      {...otherProps}
    >
      {children}
    </Button>
  )
}

DownloadButton.propTypes = {
  /**
   * Optionally override the standard button text
   */
  children: PropTypes.node,
  /**
   * isProminent is for the usage of this button in the Footer
   */
  isProminent: PropTypes.bool
}

DownloadButton.defaultProps = {
  children: 'Export data'
}

export default DownloadButton
